import { Component } from '@angular/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-payment-success-popup',
    templateUrl: './payment-success-popup.component.html',
    styleUrls: ['./payment-success-popup.component.scss'],
    standalone: false
})
export class PaymentSuccessPopupComponent {
  constructor(private modalRef: ModalOverlayRef) {
    this.modalRef.backgroundClicked();
  }

  public close(result: boolean) {
    this.modalRef.close(result);
  }
}
